import { c as _c } from "react/compiler-runtime";
import { TimeSlot, TimeSlotsFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { EVENTS_API } from '../api/events-api';
import { EventTypeEnum } from '../enums/event-type-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useOnceTrue } from 'shared/hooks/use-once-true';
interface UseTimeSlotsInterface {
  filter: TimeSlotsFilterInterface;
  eventType: EventTypeEnum;
  bookingIdToBeRescheduled: number;
  opened?: boolean;
}
export function useTimeSlots(t0) {
  const $ = _c(13);
  const {
    filter,
    eventType,
    bookingIdToBeRescheduled,
    opened
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const allowed = useOnceTrue(!!opened);
  let t2;
  if ($[1] !== allowed || $[2] !== bookingIdToBeRescheduled || $[3] !== eventType || $[4] !== filter || $[5] !== user) {
    t2 = () => {
      if (user && allowed) {
        return [`${EVENTS_API}/time-slots?rescheduleType=${eventType}&bookingIdToBeRescheduled=${bookingIdToBeRescheduled}&eventId=${filter.eventId}&startDate=${filter.dateRange.startDate}&endDate=${filter.dateRange.endDate}&timezone=${user.timezone}`, RequestModuleEnum.Calendar];
      }
      return null;
    };
    $[1] = allowed;
    $[2] = bookingIdToBeRescheduled;
    $[3] = eventType;
    $[4] = filter;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: t3,
    mutate,
    isLoading
  } = useControlledSwr(t2, fetcher);
  let t4;
  if ($[7] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const slots = t4;
  let t5;
  if ($[9] !== isLoading || $[10] !== mutate || $[11] !== slots) {
    t5 = {
      slots,
      isLoading,
      mutate
    };
    $[9] = isLoading;
    $[10] = mutate;
    $[11] = slots;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}